let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("6Wd6R")]).then(() => parcelRequire('zjy0N'));